import { createGlobalState } from '@vueuse/core';
import type { FeatureName, FeatureFlags } from '~/types/feature.types';

export const useFeatureStore = createGlobalState(
  () => {
    const { gtmPush } = useTracking();
    const { user } = useUserStore();

    const state = reactive<{
      features: FeatureFlags;
      featuresLoaded: boolean;
      featuresLoadFailed: boolean;
    }>({
      features: {},
      featuresLoaded: false,
      featuresLoadFailed: false,
    });

    const features = computed(() => state.features);

    const isEnabled = (featureName: FeatureName): boolean => {
      return !!state.features[featureName];
    };

    const updateFeatures = async () => {
      try {
        const data = await $fetch<FeatureFlags>('/api/auth/user/features');
        state.featuresLoadFailed = false;
        if (data) {
          state.features = data;

          const enabledFeatures = Object.entries(data)
            .filter(([, enabled]) => enabled)
            .map(([feature]) => feature)
            .join(',');

          gtmPush({
            event: 'enabled_features',
            features: enabledFeatures,
            user: {
              plan_type: user.value?.subscription?.type,
            },
          });
        }

      } catch (error) {
        state.featuresLoadFailed = true;
        console.error('Failed to fetch user features:', error);
      } finally {
        state.featuresLoaded = true;
      }
    };

    return {
      features,
      isEnabled,
      updateFeatures,
      featuresLoaded: computed(() => state.featuresLoaded),
      featuresLoadFailed: computed(() => state.featuresLoadFailed),
    };
  },
);